export const setPageTitle = (title: string) => {
  document.getElementsByTagName('title')[0].innerHTML = title
    .replace('<', '&lt;')
    .replace('>', '&gt;')
    .replace(' & ', ' &amp; ')
  document.title = title
}
